<template>
  <div id="home">
    <div class="home_banner">
      <div class="home_banner_box">
        <div class="left">
          <h1>巨掌数据</h1>
          <p>让数据更懂你，让推广更简单</p>
          <span>你的优质合作伙伴，现已获得苹果高额授信</span>
        </div>
        <div class="right">
          <img src="https://static.adjuz.net/adjuz-website/home_logo_1.gif" alt="">
        </div>
      </div>
    </div>
    <div class="home_bkg">
      <div class="h1_title">
        <h1>业务生态</h1>
        <p>专注移动营销数据赋能，探索效果领域无限可能</p>
      </div>
      <div class="home_sheng">
        <div class="left">
          <div v-for="(ele,index) in shenglist" :key="index" :class="{left_bgk: shenglistindex == index}" @mouseover="shenglistindex = index">
            <p>{{ele.title}}</p>
            <span>{{ele.p}}</span>
            <!-- <img src="./right_jian.png" alt="" v-if="shenglistindex == index"> -->
            <!-- <b v-if="shenglistindex == index"></b> -->
          </div>
        </div>
        <div class="right">
          <!-- :class="{three_index: shenglistindex == 2}" -->
          <img :src="shenglist[shenglistindex].img" alt="">
        </div>
      </div>
      <div class="h1_title">
        <h1>行业动态</h1>
        <p>行业最新资讯，一手掌握</p>
      </div>
      <div class="home_new">
        <ul>
          <li v-for="(ele,index) in newListall" :key="index" v-if="index < 3" @click="opennews(ele.jumpLink)">
            <div class="div">
              <img :src="ele.imgUrl" alt="">
            </div>
            <p>{{ele.title}}</p>
          </li>
        </ul>
        <div class="btn" @click="tonews('industry')">更多资讯</div>
      </div>
      <div class="h1_title">
        <h1>企业动态</h1>
        <p>公司实时动态，一手掌握</p>
      </div>
      <div class="home_new">
        <ul>
          <li v-for="(ele,index) in newListall2" :key="index" v-if="index < 3" @click="opennews(ele.jumpLink)">
            <div class="div">
              <img :src="ele.imgUrl" alt="">
            </div>
            <p>{{ele.title}}</p>
          </li>
        </ul>
        <div class="btn" @click="tonews('enterprise')">更多资讯</div>
      </div>
    </div>
    <div class="h1_title">
      <h1>部分合作伙伴</h1>
      <p>累计服务超过2000家企业和应用开发者，拥有一批互信共赢的头部企业</p>
    </div>
    <div class="home_fr" style="margin-bottom: 30px;">
      <section>
        <div v-for="(ele,index) in frlist" :key="index" :class="{nomargin: index % 4 == 0}">
          <img :src="ele" alt="">
        </div>
      </section>
      <!-- <div class="home_fr_mo" @click="tofriend">
        查看更多
      </div> -->
    </div>
    <footerbom></footerbom>
  </div>
</template> 
<script type="text/javascript">
export default {
  data() {
    return {
      num: 0,
      shenglistindex: 0,
      shenglist: [
        {
          title: "巨掌ASO",
          p: "苹果应用商店优化：App store opetimization，简称“ASO”，即优化关键词覆盖排名等。",
          img: require("./sheng1.png"),
        },
        {
          title: "巨掌ASA",
          p: "苹果应用商店搜索市场：App Store Search Marketing，简称ASM；苹果官方又称为Search Ads，简称ASA。",
          img: require("./sheng2.png"),
        },
        {
          title: "巨掌信息流",
          p: "聚集优势媒体代理（头条、抖音、百度、快手）为客户打造运维一体。",
          img: require('./website_16.png'),
        },
      ],
      frlist: [
        require("./home_fr1.png"),
        require("./home_fr2.png"),
        require("./home_fr3.png"),
        require("./home_fr4.png"),
        require("./home_fr5.png"),
        require("./home_fr6.png"),
        require("./home_fr7.png"),
        require("./home_fr8.png"),
        require("./home_fr9.png"),
        require("./home_fr10.png"),
        require("./home_fr11.png"),
        require("./home_fr12.png"),
      ],
      newListall: [],
      newListall2: []
    };
  },
  computed: {},
  components: {},
  created() {
    this.GetNewsInfoList()
  },
  destroyed() { },
  mounted() { },
  methods: {
    tofriend() {
      window.open(this.$router.resolve({ path: "/friend" }).href, "_blank");
    },
    tonews(type) {
      window.open(this.$router.resolve({
        path: "/news", query: {
          type
        }
      }).href, "_blank");
    },
    opennews(alink) {
      window.open(alink);
    },
    /**获取列表 */
    GetNewsInfoList() {
      let url = "https://api.asa.adjz.com/api/Tool/GetNewsInfoList";
      this.$https.get(url).then((res) => {
        res.data.map((ele, index) => {
          if (ele.tagsName.indexOf('企业动态') == -1) {
            this.newListall.push(ele)
          } else {
            this.newListall2.push(ele)
          }
        })
      });
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes animation1 {
  0% {
    width: 81px;
    height: 81px;
  }
  50% {
    width: 92px;
    height: 92px;
  }
  0% {
    width: 81px;
    height: 81px;
  }
}
#home {
  min-width: 1200px;
  .home_banner {
    width: 100%;
    height: 500px;
    background: url(https://static.adjuz.net/asmmaster/img/website_1.jpg)
      no-repeat center center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -1px;
    .home_banner_box {
      width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
    }
    .left {
      h1 {
        font-size: 52px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #fefefe;
      }
      p {
        height: 32px;
        font-size: 32px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fefefe;
        margin: 30px 0 46px;
      }
      span {
        height: 25px;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fefefe;
        white-space: nowrap;
      }
    }
    .right {
      width: 800px;
      position: relative;
      height: 500px;
      img {
        width: 850px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: -150px;
      }
    }
  }
  .h1_title {
    width: 100%;
    text-align: center;
    margin: 80px 0 50px;
    h1 {
      font-size: 36px;
      text-align: center;
      position: relative;
      margin: 60px 0 40px;
      letter-spacing: 4px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      &::after {
        position: absolute;
        content: "";
        width: 70px;
        height: 4px;
        background: #409eff;
        bottom: -16px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    p {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }
  }
  //生态业务
  .home_sheng {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .left {
      display: flex;
      flex-direction: column;
      width: 536px;
      div {
        flex: 1;
        box-sizing: border-box;
        padding: 32px 16px 16px 46px;
        position: relative;
        transition: all 0.2s;
        &.left_bgk {
          //background: rgba(16, 142, 233, 0.15);
          // p,
          // span {
          //   color: #409eff;
          // }
          box-shadow: 0px 5px 5px 1px rgba(17, 130, 255, 0.1);
          border-radius: 12px;
        }
        b {
          position: absolute;
          left: 0;
          height: 70px;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          background: #409eff;
        }
        p {
          font-size: 24px;
          color: #333;
          margin-bottom: 16px;
          font-weight: 600;
        }
        span {
          display: block;
          font-size: 16px;
          color: #666;
          line-height: 26px;
          letter-spacing: 3px;
        }
        img {
          margin-top: 20px;
        }
      }
    }
    .right {
      width: 500px;
      height: 500px;
      img {
        width: 500px;
        // height: 500px;
        margin-top: -40px;
        &.three_index {
          margin: 20px 0 0 -40px;
        }
      }
    }
  }
  //最新动态
  .home_new {
    width: 100%;
    ul {
      width: 1200px;
      display: flex;
      margin: 0 auto;
      justify-content: space-between;
      li {
        width: 380px;
        background: #ffffff;
        box-shadow: 0px 5px 5px 1px rgba(17, 130, 255, 0.1);
        border-radius: 12px;
        overflow: hidden;
        transition: all 0.5s;
        cursor: pointer;
        &:hover {
          transform: translateY(-10px);
          img {
            transform: scale(1.2);
          }
        }
        .div {
          width: 100%;
          height: 161px;
          overflow: hidden;
        }
        img {
          width: 100%;
          height: 161px;
          transition: all 0.5s;
        }
        p {
          width: 100%;
          height: 90px;
          box-sizing: border-box;
          padding: 20px 26px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          transition: all 0.2s;
          &:hover {
            color: #108ee9;
            text-decoration: underline;
          }
        }
      }
    }
    .btn {
      margin: 50px auto;
      text-align: center;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
      cursor: pointer;
    }
  }
  //合作伙伴
  .home_fr {
    width: 100%;
    section {
      width: 1200px;
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
      div {
        width: 20%;
        height: 96px;
        margin-bottom: 30px;
        margin-left: 6.66%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.5s;
        border-radius: 10px;
        &.nomargin {
          margin-left: 0;
        }
        &:hover {
          box-shadow: 0 8px 8px 0 #e0e6e7;
          transform: translateY(-6px);
        }
      }
    }
    .home_fr_mo {
      text-align: center;
      margin: 24px 0 56px;
      font-size: 18px;
      letter-spacing: 2px;
      cursor: pointer;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
    }
  }
  .home_bkg {
    background-image: url("https://static.adjuz.net/asmmaster/img/website_5.png");
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
    width: 100%;
  }
}
</style>
<style lang="less">
.banner_video {
  .vjs-poster {
    height: 622px !important;
    background-size: 100% 100% !important;
  }
  video {
    width: 100% !important;
    height: 644px !important;
    object-fit: fill !important;
  }
  .vjs-big-play-button {
    display: none !important;
  }
  .vjs-control-bar {
    display: none !important;
  }
  .video-js.vjs-ended .vjs-big-play-button {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/index.vue